import HTTP from '@/services/http-common'
import alert from '@/services/alert'
import handleCall from '@/services/response-handler'
import type { CreateEmployee, EmployeeDetails, UpdateEmployee } from '@/types/employee'

export default {
  get: async (employeeId: string) =>
    handleCall<EmployeeDetails>(async () => {
      return await HTTP.get(`/employees/${employeeId}`)
    }),

  getAll: async (role: string | null = null) =>
    handleCall<EmployeeDetails[]>(async () => {
      return await HTTP.get(role ? `/employees/${role}s` : '/employees')
    }),

  create: async ({
    firstName,
    lastName,
    email,
    countries,
    isTechSupportAdmin,
    isAccountant,
    language,
    status,
    passwordConfirmation,
    password,
    isOwner,
    isTechSupport,
    isMarketer,
    isTechSupportAdminPlus,
    isRefiner
  }: CreateEmployee) =>
    handleCall<{ id: string }>(async () => {
      const response = await HTTP.post(`/employees`, {
        currentStatus: 'active',
        firstName,
        lastName,
        email,
        countries,
        isTechSupportAdmin,
        status,
        passwordConfirmation,
        password,
        isAccountant,
        language,
        isOwner,
        isTechSupport,
        isMarketer,
        isTechSupportAdminPlus,
        isRefiner
      })

      alert.success(`Employee Created successfully`)

      return response
    }),

  update: async (
    employeeId: string,
    {
      currentStatus,

      firstName,
      lastName,
      email,
      countries,
      isTechSupportAdmin,
      isAccountant,
      language,
      isOwner,
      isTechSupport,
      isMarketer,
      isTechSupportAdminPlus,
      isRefiner
    }: UpdateEmployee
  ) =>
    handleCall(async () => {
      const response = await HTTP.put(`/employees/${employeeId}`, {
        currentStatus,
        firstName,
        lastName,
        email,
        countries,
        isTechSupportAdmin,
        isAccountant,
        language,
        isOwner,
        isTechSupport,
        isMarketer,
        isTechSupportAdminPlus,
        isRefiner
      })

      alert.success(`Employee with ID ${employeeId} Updated successfully`)

      return response
    }),

  delete: async (employeeId: string) =>
    handleCall(async () => {
      const response = await HTTP.delete(`/employees/${employeeId}`)

      alert.success(`Employee with ID ${employeeId} Deleted successfully`)

      return response
    }),

  activateOrInactivate: async (employeeId: string, { currentStatus }: { currentStatus: string }) =>
    handleCall(async () => {
      const EmployeeDetails = await HTTP.get(`/employees/${employeeId}`)

      const response = await HTTP.put(`/employees/${employeeId}`, {
        ...EmployeeDetails.data.data,
        currentStatus
      })

      alert.success(`Employee with ID ${employeeId} Updated successfully`)

      return response
    }),

  resetPassword: async (
    employeeId: string,
    { password, passwordConfirmation }: { password: string; passwordConfirmation: string }
  ) =>
    handleCall(async () => {
      const response = await HTTP.put(`/employees/${employeeId}/reset-password`, {
        password,
        passwordConfirmation
      })

      alert.success(`Password of Employee with ID ${employeeId} Updated successfully`)

      return response
    })
}
